export const getSignedImageUrl = async (mediaId) => {
    try {
      let baseUrl =
      process.env.NODE_ENV === 'development'
          ? process.env.REACT_APP_DEVELOP
          : process.env.REACT_APP_PROD;
        const token = await localStorage.getItem('token');
        const res = await fetch(
            `${baseUrl}/v1/media/${mediaId}`,
            {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return res.url;
    } catch (err) {
        console.log("getSignedImageUrl error", err);
        return null;
    }
  };